import { CivilStatus } from "../../models/enum/civil-status.enum";

export class DropdownLists {
    public static documentPersonWorker = [
        { name: 'Cédula de ciudadanía', value: 'CO1C' },
        { name: 'Tarjeta de identidad', value: 'CO1T' },
        { name: 'Carnet Diplomático', value: 'CO1D' },
        { name: 'Cédula de Extranjería', value: 'CO1E' },
        { name: 'Pasaporte', value: 'CO1P' },
        { name: 'Permiso Especial de Permanencia', value: 'CO1V' },
        { name: 'Permiso por Protección Temporal', value: 'CO1W' }
    ];
    public static documentPerson = [
        { name: 'Registro Civil', value: 'CO1L' },
        { name: 'Cédula de ciudadanía', value: 'CO1C' },
        { name: 'Tarjeta de identidad', value: 'CO1T' },
        { name: 'Carnet Diplomático', value: 'CO1D' },
        { name: 'Cédula de Extranjería', value: 'CO1E' },
        { name: 'Pasaporte', value: 'CO1P' },
        { name: 'Permiso por Protección Temporal', value: 'CO1W' }
    ];
    public static documentTypeConyuge = [
        { name: 'Cédula de ciudadanía', value: 'CO1C' },
        { name: 'Tarjeta de identidad', value: 'CO1T' },
        { name: 'Carnet Diplomático', value: 'CO1D' },
        { name: 'Cédula de Extranjería', value: 'CO1E' },
        { name: 'Pasaporte', value: 'CO1P' },
        { name: 'Permiso por Protección Temporal', value: 'CO1W' }
    ];
    public static documentTypeBeneficiary = [
        { name: 'Registro Civil', value: 'CO1L' },
        { name: 'Tarjeta de identidad', value: 'CO1T' },
        { name: 'Cédula de ciudadanía', value: 'CO1C' },
        { name: 'Carnet Diplomático', value: 'CO1D' },
        { name: 'Cédula de Extranjería', value: 'CO1E' },
        { name: 'Pasaporte', value: 'CO1P' },
        { name: 'Permiso por Protección Temporal', value: 'CO1W' }
    ];
    public static genders = [
        { name: 'Femenino (F)', value: 1 },
        { name: 'Masculino (M)', value: 2 }
    ];
    public static contracts = [
        { name: 'Fijo', value: '01' },
        { name: 'Indefinido', value: '02' }
    ];
    // public static civilStatus = [
    //     { name: 'Soltero/a', value: 1 },
    //     { name: 'Casado/a', value: 2 },
    //     { name: 'Separado/a', value: 3 },
    //     { name: 'Viudo/a', value: 4 },
    //     { name: 'Unión Libre', value: 5 },
    // ];

    public static civilStatus: { codigo: string; desc: string }[] = [
        { codigo: CivilStatus.SEPARATED.codigo, desc: CivilStatus.SEPARATED.desc },
        { codigo: CivilStatus.WIDOWER.codigo, desc: CivilStatus.WIDOWER.desc },
        { codigo: CivilStatus.MARRIED.codigo, desc: CivilStatus.MARRIED.desc },
        { codigo: CivilStatus.SINGLE.codigo, desc: CivilStatus.SINGLE.desc },
        { codigo: CivilStatus.FREE_UNION.codigo,
          desc: CivilStatus.FREE_UNION.desc,
        },
      ];
    public static activityTypes = [
        { name: 'Operativo', value: '01' },
        { name: 'Administrativo', value: '02' },
        { name: 'Directivo', value: '03' },
        { name: 'Staff', value: '04' },
        { name: 'Ejecutivo', value: '05' },
        { name: 'Profesional', value: '06' },
        { name: 'Técnico', value: '07' },
        { name: 'Representante Legal', value: '09' },
        { name: 'Diplomático', value: '13' },
        { name: 'Servicio Domestico', value: '14' },
    ];
    public static salaryTypes = [
        { name: 'Integral', value: '01' },
        { name: 'Fijo', value: '02' },
    ];
    public static documentCompanies = [
        { name: 'Nit', value: 'CO1N' },
        { name: 'Cédula de ciudadanía', value: 'CO1C' },
        { name: 'Carnet Diplomático', value: 'CO1D' },
        { name: 'Cédula de Extranjería', value: 'CO1E' },
        { name: 'Pasaporte', value: 'CO1P' },
    ];
    public static kinshipTypes = [
        { name: 'Hijo', value: '1' },
        { name: 'Hijastro', value: '2' },
        { name: 'Padre', value: '3' },
        { name: 'Madre', value: '33' },
        { name: 'Hermano', value: '4' }
    ];
    public static occupations = [
        { name: 'Hogar', value: '01' },
        { name: 'Empleado(a)', value: '02' },
        { name: 'Independiente', value: '03' },
        { name: 'Desempleado(a)', value: '04' },
        { name: 'Pensionado(a)', value: '05' }
    ];
    public static radioDiscapacidad = [
        { name: 'Si', value: 'X' },
        { name: 'No', value: '' }
    ];
    public static affiliateStatus = [
      { name: 'En proceso', value: '01' },
      { name: 'Trámite Exitoso', value: '02' },
      { name: 'Con errores', value: '03' },
      { name: 'COMPLETADO', value: '8' },
      { name: 'COMPLETADO_MANUAL', value: '10' },
      { name: 'RECHAZADO', value: '4' },
    ];
    public static typeRequest = [
        { name: 'Solicitud', value: 'Solicitud' },
        { name: 'Queja/reclamo', value: 'Queja/reclamo' },
        { name: 'Sugerencia', value: 'Sugerencia' },
        { name: 'Felicitación', value: 'Felicitación' }
    ];
    public static categorys = [
        { name: 'Actualización Datos De Ubicación Y Contacto Empleadores', value: '128658',message:''},
        { name: 'Cambio De Ciclo De Aportes Pagados', value: '9297',message:'Esta solicitud tendrá un tiempo de solución de 8 días hábiles' },
        { name: 'Certificación Del Pago De Aportes', value: '9298',message:'Esta solicitud tendrá un tiempo de solución de 8 días hábiles' },
        { name: 'Receso De Actividad', value: '9307',message:'' },
        { name: 'Relación De Trabajadores Empresa Con Paz Y Salvo Para Retiro / Traslado', value: '10756',message:'' },
        { name: 'Reporte De Trabajadores Afiliados Y Grupo Familiar', value: '9294',message:'' },
        { name: 'Reporte De Trabajadores Con Acreditación Y Pago De Cuota Monetaria', value: '9497',message:'' },
        { name: 'Retiro Masivo/ Reingreso Masivo Trabajadores', value: '128660',message:'' },
        { name: 'Solicitud Aclaración Estado De Cuenta De Aportes Contra PILA', value: '9300',message:'Esta solicitud tendrá un tiempo de solución de 11 días hábiles' },
        { name: 'Solicitud De Traslado O Devolución De Aportes', value: '9302',message:'Esta solicitud tendrá un tiempo de solución de 11 días hábiles' },
        {name:'Otros - Motivos',value:'45642',message:''}
    ];
    public static queryStatus = [
        { name: 'En proceso', value: 'PENDING' },
        { name: 'Con errores', value: 'FAILED' },
        { name: 'Trámite Exitoso', value: 'FINISHED' }
    ];
    public static consultaMasiva = [
      { name: 'Afiliaciones', value: 'afiliaciones' },
      // { name: 'Estado cuenta cuota monetaria', value: 'estado_cm' }, // Funcionalidad para Estado de Cuenta Masivo.
      // { name: 'Subsidio Escolar', value: 'subsidio_escolar' },
      // { name: 'Abono subsidio familiar', value: 'subsidios_cm' }
       /*,

        { name: 'Estado certificado escolar', value: 'estado_certif_escolar' },
        { name: 'Tarjeta de afiliación multiservicio - TAMS Créditos', value: 'tams' },
        { name: 'Bono lonchera', value: 'bono-lonchera' },
        { name: 'Aportes', value: 'aportes' }*/
    ];
    public static queryDisaStatus = [
        { name: 'En proceso', value: 1 },
        { name: 'Devuelto', value: 2 },
        { name: 'Trámite Exitoso', value: 3 },
        { name: 'Con errores', value: 5 },
        { name: 'Con errores', value: 4 }
    ];
}
